module.exports = __webpack_public_path__ + "static/media/impresion.b3029bec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/impresion.svg
// module id = 93
// module chunks = 0